export class Operation {
  id: string;
  name: string;
  count_users: number;
  count_points: number;
  logo_url: string;

  constructor(obj?) {
    this.id = obj.operation_id ? obj.operation_id : obj.id;
    this.name = obj.name ? obj.name : obj.operation?.operation?.name;
    this.count_users = obj.count_users ? obj.count_users : 0;
    this.count_points = obj.count_points ? obj.count_points : 0;
    this.logo_url = obj.operation?.operation?.logo_url;
  }
}
